export default `<p>
    <span style=";font-family:宋体;font-size:16px;font-weight: bold;">朋友圈运营次数包购买说明</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><br/></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">欢迎购买并使用“朋友圈运营次数包”。购买前请仔细阅读本说明。完成支付即表示门店已理解并同意以下内容。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">一、产品内容</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">次数包用于门店在“朋友圈运营”模块中使用自动发布朋友圈、自动点赞等服务。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">套餐包含的发布次数、点赞次数、销售价格、有效期及购买限制，以购买页面展示的信息为准。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">次数包归购买门店所有，可供该门店已登录并获得授权的智能体微信号共同使用，不支持转移至其他门店。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">二、购买与到账</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">门店可通过微信支付、支付宝等平台支持的方式购买次数包。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">支付成功后，套餐次数原则上实时到账；如因网络或系统原因延迟，请以支付记录及最终到账结果为准。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">标记为“允许门店购买一次”的套餐，同一门店仅可支付成功一次，不可重复购买。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">每笔购买均生成支付记录，门店可在计费中心查询套餐、金额、支付方式、购买时间及到账状态。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">三、次数扣减规则</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">朋友圈发布 ：没生成一张图片，扣减一张数量。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">朋友圈点赞成功：每成功点赞一次，扣减1次点赞次数。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">内容生成、人工审核及重新生成阶段不扣减发布次数。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">发布失败、审核未通过、任务取消、点赞失败或策略跳过，不扣减次数。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">因门店主动删除已成功发布的朋友圈，已扣减次数不予返还。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">实际扣减结果以系统使用计费记录为准。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">四、有效期</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">次数包有效期自支付成功并到账之日起计算。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">有效期内未使用完的次数，可继续使用；超过有效期后，剩余次数自动失效。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">不同批次购买的次数包分别计算有效期，系统可优先扣减较早到期的次数。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">五、退款说明</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">次数包属于即时到账的数字化服务，到账后原则上不支持无理由退款。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">因重复扣款、支付成功但长期未到账等平台原因，可联系平台核实处理。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">已使用部分次数的套餐，原则上不支持整单退款；经平台确认需要退款的，按实际情况处理。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">六、门店责任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">门店应确保登录系统的微信号已取得合法授权，并妥善保管账号信息。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">门店应对配置的发布计划、素材范围、文案风格及最终发布内容负责。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">门店不得利用本服务发布违法违规、虚假宣传、侵权或损害他人权益的内容。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">因微信平台规则、账号限制或门店配置不当导致任务无法执行的，平台将按实际执行结果决定是否扣减次数。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">七、服务调整</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">平台可根据业务运营、微信平台规则或系统升级需要调整服务流程，但不会无故扣减门店已购买且仍在有效期内的次数。发生重大调整时，平台将通过系统公告等方式通知门店。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px;font-weight: bold;">八、其他</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">套餐购买记录、到账记录和使用计费记录均以系统数据为准。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">本说明未尽事项，按照平台其他服务协议及相关法律法规执行。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">如有疑问，可联系平台客服处理。</span>
</p>
<p>
<br/>
</p>

`